import type { LucideIcon } from 'lucide-react';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-manejai-sand/60 text-manejai-moss mb-4">
        <Icon className="h-7 w-7" />
      </div>
      <h3 className="font-display text-lg font-semibold text-manejai-forest">{title}</h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-manejai-bark/70">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
